export const setSiteTheme = (mode) => {
  return { type: 'SET_SITE_THEME', mode }
}
